import { Injectable } from '@angular/core';
import {
  SearchAction,
  SearchableItem,
  SearchDataLoaderService,
  SearchProvider,
} from '@core/search';
import {
  PermissionPayload,
  buildPermissionsIndex,
} from './permissions-search-index.builder';

/**
 * Permissions-domain search provider. Loads German/English keyword files
 * lazily and produces 138 SearchableItems for the IntelligentSearchService.
 */
@Injectable({ providedIn: 'root' })
export class PermissionsSearchProvider implements SearchProvider<PermissionPayload> {
  readonly id = 'permissions';
  readonly displayNameKey = 'USER_PERMISSIONS.V2.SEARCH.GROUP_LABEL';

  constructor(private loader: SearchDataLoaderService) {}

  async getItems(lang: string): Promise<SearchableItem<PermissionPayload>[]> {
    const keywords = await this.loader.loadProviderData<Record<string, string[]>>(
      `permission-keywords.${lang}`,
      lang === 'de'
        ? () => import('./data/permission-keywords.de.json').then((m) => m.default)
        : () => import('./data/permission-keywords.en.json').then((m) => m.default)
    );
    return buildPermissionsIndex(keywords);
  }

  getActionFor(item: SearchableItem<PermissionPayload>): SearchAction {
    return {
      type: 'select-in-dialog',
      dialogContext: {
        module: item.payload.module,
        itemKey: item.payload.permissionKey,
      },
    };
  }
}
